module.exports = "<app-input-field\n  [form]=\"form\"\n  type=\"number\"\n  [id]=\"id\"\n  [controlName]=\"controlName\"\n  [key]=\"key\"\n  [class]=\"class\"\n  [minlength]=\"minlength\"\n  [maxlength]=\"maxlength\"\n  [hideLabel]=\"hideLabel\"\n  [hideErrors]=\"hideErrors\"\n  [step]=\"step\"\n></app-input-field>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/input-number-field/input-number-field.component.html
// module id = ../../../../../src/app/shared/components/forms/input-number-field/input-number-field.component.html
// module chunks = main